import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Footer = () => {
  return (
    <footer>
      <span></span>
    </footer>
  );
};

export default Footer;
